import React from 'react';
import PropTypes from 'prop-types';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');


function Flash({ show, mailto }) {
  if (show) {
    return (
      <div className="email-pdf-alert flash-success">
        <div className="alert alert-success">
          The filing has been mailed to { mailto }
        </div>
      </div>
    );
  }
  return null;
}

Flash.defaultProps = {
  show: false,
  mailto: '',
};

Flash.propTypes = {
  show: PropTypes.bool,
  mailto: PropTypes.string,
};

export default Flash;




/** WEBPACK FOOTER **
 ** ./src/components/case/docket/Flash.jsx
 **/